const FLAG_PREFIX = 'bukSyncPending:'

export const BUK_SYNC_STARTED_EVENT = 'buk-sync:started'

const flagKey = (businessId) => `${FLAG_PREFIX}${businessId}`

export const markBukSyncPending = (businessId) => {
  if (!businessId) return
  try {
    localStorage.setItem(flagKey(businessId), '1')
  } catch (err) {
    console.error('Error setting Buk sync pending flag:', err)
  }
  window.dispatchEvent(new CustomEvent(BUK_SYNC_STARTED_EVENT, { detail: { businessId } }))
}

export const clearBukSyncPending = (businessId) => {
  if (!businessId) return
  try {
    localStorage.removeItem(flagKey(businessId))
  } catch (err) {
    console.error('Error clearing Buk sync pending flag:', err)
  }
}

export const isBukSyncPending = (businessId) => {
  if (!businessId) return false
  try {
    return localStorage.getItem(flagKey(businessId)) === '1'
  } catch (err) {
    return false
  }
}
